import { api } from "api/api";
import { rejects } from "assert";
import { AxiosError } from "axios";
import CentroCusto from "model/administracao/cadastro/centrocusto/CentroCusto";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import RejeitarViagemRequest from "model/viagem/RejeitarViagemRequest";
import Viagem from "model/viagem/Viagem";
import { resolve } from "path";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class ViagemAprovacaoService implements BaseServiceCadastros<Viagem> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {

            let url = `/viagem/lista/aprovar`;
            url += getFilters(filters)

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Viagem>((resolve, reject): void => {
            api
                .get(`/viagem/consultar/${id}`)
                .then(response => {
                    const viagem: Viagem = response.data;
                    resolve(viagem);
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(viagem: Viagem) {
        return new Promise<Viagem>((resolve, reject): void => {
            let url = `/viagem/incluir`;
            api
                .post(url, JSON.stringify(viagem))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(viagem: Viagem) {
        return new Promise<Viagem>((resolve, reject): void => {
            api
                .put(`/viagem/editar`, JSON.stringify(viagem))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/viagem/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    aprovar(id: number) {
        return new Promise<Viagem>((resolve, reject): void => {
            api
                .post(`/viagem/aprovar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    rejeitar(dados: RejeitarViagemRequest) {
        return new Promise<Viagem>((resolve, reject): void => {
            api
                .post(`/viagem/rejeitar`, dados)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getCentroCustoDisponiveis() {
        return new Promise<CentroCusto[]>((resolve, reject): void => {
            api
                .get(`/viagem/centroscusto`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getCentroCustoUsuario() {
        return new Promise<number[]>((resolve, reject): void => {
            api
                .get(`/viagem/centrocusto/usuario`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getSituacao(situacao: string): string {

        if (situacao === 'ABERTA') {
            return 'Aberta';
        } else if (situacao === 'ENVIADA_APROVACAO') {
            return 'Enviada para aprovação';
        } else if (situacao === "APROVADA") {
            return "Aprovada";
        } else if (situacao === "REJEITADA") {
            return "Rejeitada";
        } else if (situacao === "CANCELADA") {
            return "Cancelada";
        }

        return 'Criada';
    }

    getTipoLocomocao(situacao: string): string {

        if (situacao === 'CARRO_EMPRESA') {
            return 'Carro Empresa';
        } else if (situacao === 'CARRO_PROPRIO') {
            return 'Carro Próprio';
        } else if (situacao === "AVIAO_EMPRESA") {
            return "Avião Empresa";
        } else if (situacao === "AVIAO_CARREIRA") {
            return "Avião Carreira";
        } else if (situacao === "ONIBUS") {
            return "Ônibus";
        }

        return 'Outros';
    }

    getSituacaoAprovacao(situacao: string): string {

        if (situacao === 'ABERTA') {
            return 'Aberta';
        } 
        if (situacao === "APROVADA") {
            return "Aprovada";
        } 
        if (situacao === "REJEITADA") {
            return "Rejeitada";
        }
        if (situacao === "NAO_RESPONDIDA") {
            return "Não respondida";
        }

        return '';
    }

}

export default ViagemAprovacaoService;
